module.exports = __webpack_public_path__ + "img/fuel-injection-schematic-light-AS.321c632b.png";